import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaShieldAlt } from "react-icons/fa";
import carImage from "../Assets/carLogin.jpg";
import { SITE_LOGO, SITE_LOGO_ALT } from "../Utils/imageUtils";
import { authApi, setAccessToken, presenceApi } from "../services/api";
import "./AdminLogin.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await authApi.login({ email: email.trim(), password });
      if (res.user?.role !== "admin") {
        setAccessToken(null);
        await authApi.logout().catch(() => {});
        setError("Access denied. Please use a valid administrator account.");
        return;
      }
      setAccessToken(res.accessToken);
      localStorage.setItem("adminUser", JSON.stringify(res.user));
      presenceApi.ping().catch(() => {});
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed. Check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <aside className="admin-login-visual" aria-hidden="true">
        <div
          className="admin-login-visual-bg"
          style={{ backgroundImage: `url(${carImage})` }}
        />
      </aside>

      <main className="admin-login-panel">
        <div className="admin-login-card">
          <div className="admin-login-card-head">
            <span className="admin-login-badge">
              <FaShieldAlt aria-hidden="true" /> Admin access
            </span>
            <img src={SITE_LOGO} alt={SITE_LOGO_ALT} className="admin-login-logo" />
            <h1>Administrator sign in</h1>
            <p>Enter your credentials to open the admin panel</p>
          </div>

          {error ? <div className="admin-login-error">{error}</div> : null}

          <form onSubmit={handleSubmit}>
            <div className="admin-login-field">
              <label htmlFor="admin-email">Email address</label>
              <div className="admin-login-input-wrap">
                <FaEnvelope className="admin-login-input-icon" aria-hidden="true" />
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@carsinfinity.com"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="admin-login-field">
              <label htmlFor="admin-password">Password</label>
              <div className="admin-login-input-wrap">
                <FaLock className="admin-login-input-icon" aria-hidden="true" />
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="admin-login-submit" disabled={loading}>
              {loading ? "Signing in…" : "Sign in to Admin Panel"}
            </button>
          </form>

          <div className="admin-login-links">
            <Link to="/">← Back to website</Link>
            <Link to="/login" className="admin-login-link-accent">
              Customer login
            </Link>
            <Link to="/partner/login">Partner login</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminLogin;
